// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"38b979d8","173":"bac2e36e","203":"448cbdc7","453":"a0a213fe","520":"2720f3b3","623":"faff8c41","669":"6f237ff1","746":"d707487c","987":"835f4eb0"}[chunkId] + ".chunk.js";
};